import { SimpleForm, TextInput } from "react-admin";
import { validateValue } from "../../validations/way-of-arrival/formFields";

export const WayOfArrivalForm = () => {
  return (
    <SimpleForm>
      <TextInput
        variant="outlined"
        source="value"
        label="Value"
        validate={validateValue}
        sx={{
          minWidth: "210px",
          width: "300px",
        }}
      />
    </SimpleForm>
  );
};
